// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const AiApiSpec_addToGenerateNoteQueueCallbackSchema = z.object({
  status_code: z.number(),
  body: z.object({
    hour_id: z.optional(z.number()),
    suggestion_id: z.optional(z.coerce.string().describe("Suggestion this note will be set for")),
    project_id: z.optional(z.number()),
    label_ids: z.optional(z.array(z.number())),
    style: z.optional(z.enum(["all", "with_reference", "without_reference"]).describe("The requested style of note to be generated. ")),
    note: z.object({
      with_reference: z.optional(z.coerce.string()),
      without_reference: z.optional(z.coerce.string()),
    }).describe("The generated note/s, based on requested style."),
    timely_user_id: z.number(),
    timely_account_id: z.number(),
    tic_user_id: z.coerce.string(),
    error: z.optional(z.coerce.string()),
  }),
});
